import { render } from "./ContentManajemen.vue?vue&type=template&id=1994aef7&scoped=true"
import script from "./ContentManajemen.vue?vue&type=script&lang=js"
export * from "./ContentManajemen.vue?vue&type=script&lang=js"

import "./ContentManajemen.vue?vue&type=style&index=0&id=1994aef7&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1994aef7"]])

export default __exports__